import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { TextField, InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface BasicSearchBarProps {
	searchTerm: string;
	onSearch: (term: string) => void;
}

const BasicSearchBar: React.FC<BasicSearchBarProps> = ({ searchTerm, onSearch }) => {
	const { t } = useTranslation();

	return (
		<TextField
			className="grow"
			variant="outlined"
			placeholder={t('search')}
			value={searchTerm}
			onChange={e => onSearch(e.target.value)}
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<SearchIcon className="text-action-active" />
					</InputAdornment>
				),
			}}
		/>
	);
};

export default BasicSearchBar;
